const initialState = {
  rig: {
    intro: {
      heading: "Retirement planner",
      selectedPlan: ""
    },
    equation: {
      age: 65,
      savings: 1000000,
      income: 25,
      withdraw: 75000,
      retirementAccount: 100000,
      //sorce
      dec_socialSecurity: 10000,
      dec_otherIncome: 0,
      dec_investmentSource: 20000,
      selectedPortfolio: 2.2,
      dec_barchartData: [],
      analizeButtonClicked: 0,
      dec_pdfTable: [],
      donut: {
        donutVal: 100,
        rangetext: "",
        otherIncome: 0,
        shortfall: 0,
        excess: 0,
        rate: 2.2
      },
      fundSelected: {
        fundName: " TYPICAL CAPITAL PROTECTION FUND",
        id: 999
      }
    },
    accumulation: {
      currentAge: 45,
      retirementAge: 65,
      currentSavings: 50000,
      possibleAnnualSavings: 30000,
      possibleAnnualIRA: 0,
      annualIncomeNeeded: 40000,
      //sorce
      socialSecurity: 10000,
      acc_otherIncome: 0,
      investmentSource: 200000,
      acc_selectedPortfolio: 2.2,
      acc_id: 999,
      acc_analizeButtonClicked: 0,
      activeGlidePath: false,
      estimatedSavings: 0,
      acc_fundSelected: {
        acc_fundName: " TYPICAL CAPITAL PROTECTION FUND"
      },
      fundList: []
    }
  }
};

export default function retirement(
  state = JSON.parse(JSON.stringify(initialState)),
  action
) {
  const { payload, type } = action;

  let newState = Object.assign({}, state);
  var cmp = newState.retirement;

  switch (type) {
    case "RETIREMENT_KNOB_HANDLER":
      newState.rig.equation[`${payload.name}`] = payload.value;
      break;

    case "RETIREMENT_DONUT_HANDLER":
      newState.rig.equation.donut[`${payload.name}`] = payload.value;
      break;

    case "RETIREMENT_SELECTED_FUND":
      newState.rig.equation.fundSelected[`${payload.name}`] = payload.value;

      newState.rig.equation.fundSelected.fundName =
        payload.value == 999
          ? " TYPICAL CAPITAL PROTECTION FUND"
          : payload.value == 706
          ? " IQCIO CONSERVATIVE FUND"
          : "IQCIO MODERATE FUND";
      break;

    case "RETIREMENT_ANALYZE_HANDLER":
      newState.rig.equation[`${payload.name}`] = payload.value * 1;
      break;

    case "RETIREMENT_RESET":
      newState.rig.equation.age = 65;
      newState.rig.equation.savings = 1000000;
      newState.rig.equation.income = 25;
      newState.rig.equation.withdraw = 75000;
      newState.rig.equation.dec_barchartData = [];
      newState.rig.equation.retirementAccount = 100000;
      newState.rig.equation.dec_otherIncome = 0;
      newState.rig.equation.donut.donutVal = 100;
      newState.rig.equation.donut.otherIncome = 0;
      newState.rig.equation.donut.shortfall = 0;
      newState.rig.equation.donut.rate = 2.2;
      newState.rig.equation.donut.excess = 0;
      newState.rig.equation.donut.rangetext = "";
      newState.rig.equation.fundSelected.id = 999;
      newState.rig.equation.fundSelected.fundSelected =
        " TYPICAL CAPITAL PROTECTION FUND";
      newState.rig.equation.analizeButtonClicked = 0;
      newState.rig.equation.dec_pdfTable = [];
      break;

    case "RETIREMENT_PDF_TABLE":
      newState.rig.equation.dec_pdfTable = payload;
      break;
    case "RETIREMENT_SET_PLAN":
      // set selected plan
      newState.rig.intro.selectedPlan = payload;
      // set heading
      // if (payload === "accumulation") {
      //   newState.rig.intro.heading = "Accumulation Planner";
      // } else if (payload === "decumulation") {
      //   newState.rig.intro.heading = "Decumulation Planner";
      // } else {
      //   newState.rig.intro.heading = "Retirement planner";
      // }
      break;

    // accumulation page
    case "ACCUMULATION_SET_AGE":
      if (payload.name === "currentAge") {
        newState.rig.accumulation.currentAge = payload.value * 1;
      } else if (payload.name === "retirementAge") {
        newState.rig.accumulation.retirementAge = payload.value * 1;
      }
      break;
    case "ACCUMULATION_SET_SAVINGS_NEEDED":
      if (payload.name === "currentSavings") {
        newState.rig.accumulation.currentSavings = payload.value * 1;
      } else if (payload.name === "possibleAnnualSavings") {
        newState.rig.accumulation.possibleAnnualSavings = payload.value * 1;
      } else if (payload.name === "annualIncomeNeeded") {
        newState.rig.accumulation.annualIncomeNeeded = payload.value * 1;
      } else if (payload.name === "possibleAnnualIRA") {
        newState.rig.accumulation.possibleAnnualIRA = payload.value * 1;
      }
      break;

    case "ACCUMULATION_SETPORTFOLIO_SELECTED":
      newState.rig.accumulation.selectedPortfolio = payload.value * 1;
      break;

    case "ACCUMULATION_ANALYZE_HANDLER":
      newState.rig.accumulation.acc_analizeButtonClicked = payload.value * 1;
      break;
    case "ACCUMULATION_RESET":
      newState.rig.accumulation.currentAge = 45;
      newState.rig.accumulation.retirementAge = 65;
      newState.rig.accumulation.currentSavings = 50000;
      newState.rig.accumulation.possibleAnnualSavings = 30000;
      newState.rig.accumulation.possibleAnnualIRA = 0;
      newState.rig.accumulation.annualIncomeNeeded = 40000;
      newState.rig.accumulation.socialSecurity = 10000;
      newState.rig.accumulation.acc_otherIncome = 0;
      newState.rig.accumulation.acc_selectedPortfolio = 2.2;
      newState.rig.accumulation.acc_id = 999;
      newState.rig.accumulation.acc_fundSelected.acc_fundName =
        " TYPICAL CAPITAL PROTECTION FUND";
      newState.rig.accumulation.acc_analizeButtonClicked = 0;
      newState.rig.accumulation.estimatedSavings = 0;
      newState.rig.accumulation.activeGlidePath = false;
      newState.rig.accumulation.fundList = [];
      break;

    case "ACCUMULATION_SET_SOURCE":
      if (payload.name === "socialSecurity") {
        newState.rig.accumulation.socialSecurity = payload.value * 1;
      } else if (payload.name === "acc_otherIncome") {
        newState.rig.accumulation.acc_otherIncome = payload.value * 1;
      } else if (payload.name === "investmentSource") {
        newState.rig.accumulation.investmentSource = payload.value * 1;
      }
      break;

    case "DECUMULATION_SET_INCOME_SOURCE":
      if (payload.name === "dec_socialSecurity") {
        newState.rig.equation.dec_socialSecurity = payload.value * 1;
      } else if (payload.name === "dec_otherIncome") {
        newState.rig.equation.dec_otherIncome = payload.value * 1;
      } else if (payload.name === "dec_investmentSource") {
        newState.rig.equation.dec_investmentSource = payload.value * 1;
      }
      break;

    // set Decumulatinon values from accumulation page
    case "DECUMULATION_VALUES_SET_FROM_ACCUMULATION_PAGE":
      switch (payload.name) {
        case "dec_socialSecurity":
          newState.rig.equation.dec_socialSecurity = payload.value * 1;
          break;
        case "dec_otherIncome":
          newState.rig.equation.dec_otherIncome = payload.value * 1;
          break;
        case "dec_investmentSource":
          newState.rig.equation.dec_investmentSource = payload.value * 1;
          break;
        case "withdraw":
          newState.rig.equation.withdraw = payload.value * 1;
          break;
        case "age":
          newState.rig.equation.age = payload.value * 1;
          break;
        case "savings":
          newState.rig.equation.savings = payload.value * 1;
          break;
        case "retirementAccount":
          newState.rig.equation.retirementAccount = payload.value * 1;
          break;
      }
      break;
    case "SET_ACCUMULATION_ESTIMATEDSAVINGS":
      newState.rig.accumulation.estimatedSavings = payload.value * 1;
      break;

    case "SET_ACCUMULATION_SELECTED_PORTFOLIO":
      newState.rig.accumulation.acc_selectedPortfolio = payload.value * 1;
      break;
    case "SET_ACCUMULATION_SELECTED_ACCID":
      newState.rig.accumulation.acc_id = payload.value * 1;

      newState.rig.accumulation.acc_fundSelected.acc_fundName =
        payload.value == 999
          ? " TYPICAL CAPITAL PROTECTION FUND"
          : payload.value == 706
          ? " IQCIO CONSERVATIVE FUND"
          : "IQCIO MODERATE FUND";
      break;

    case "ACTIVE_GLIDE_PATH":
      newState.rig.accumulation.activeGlidePath = payload.value;
      break;

    case "SET_ACCUMULATION_FUNDLIST":
      newState.rig.accumulation.fundList = [...payload.value];
      break;

    default:
      return state;
  }
  return newState;
}



// WEBPACK FOOTER //
// ./src/reducers/retirement.reducer.js